(function () {
  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.eh-ticker-track').forEach(function (el) {
      if (el.dataset.ehInit) return;
      el.dataset.ehInit = '1';
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) el.style.animation = 'none';
    });
  }
  init();
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
